import styled from 'styled-components';

export const IdentificationOption = styled.div`
  padding-left: 2rem;
  margin-bottom: 1rem;
`;
